import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DeleteModal from './DeleteModal';
import NumberInput from './inputs/NumberInput';




const tableStyle = {
  headerCell: {
    color: '#A1A1A1', 
    borderBottom: '0', 
    padding: '0.5rem 0.5rem',
    fontSize:'0.8125rem',
    width:'20%'
  },
  headerRow:{
    borderBottom:'1px solid #A1A1A1'
  },
  bodyCell:{
    padding: '0.5rem 0.5rem',
    width: 'calc( 100% / 1)',
    borderBottom: '1px solid #F8F8F8',
    maxWidth: 0
  },
  actionCell:{
    padding: '0.5rem 0.5rem',
    width: 'calc( 100% / 3)',
    borderBottom: '1px solid #F8F8F8',
    maxWidth: 0
  },
};


const ActionsButton = ({onDelete, rowItem}) => {
  return (
    <>
      <IconButton sx={{ padding: 0 }} onClick={() => onDelete(rowItem)}>
        <DeleteOutlineOutlinedIcon style={{ fontSize: {lg:'1.5rem'}, color: 'black'}} />
      </IconButton>
    </>
  )
}


function TableCustom({
    tableData,
    tableLabels,
    tableFields,
    onDelete,
    onValueUpdate,
    isLoading,
    inputStyle,
    error
}) {
    const [openModal, setOpenModal] = useState(false)
    const [labelNames, setLabelNames] = useState([])
    const [dataRows, setDataRows] = useState([])
    const [dataFields, setDataFields] = useState([])

    const [ localValue, setLocalValue ] = useState("")

    const [itemDelete, setItemDelete] = useState("")

    const deleteTitle = "¿Desea eliminar el valor?"

    useEffect(() => {
        setLabelNames(tableLabels);
        setDataRows(tableData)
        setDataFields(tableFields)
    }, [tableData, tableLabels, tableFields])

    // console.log(dataRows)

    const onDeleteModal = (e) => {
        // console.log("Item to delete", e)
        setOpenModal(true)
        setItemDelete(e)
    }

    const onCloseModal = () => {
        setOpenModal(false)
        setItemDelete(null)
    }

    const onConfirmDelete = () => {
        // console.log("Deleting item", itemDelete)

        onDelete(itemDelete)
        setOpenModal(false)
    }


    return (
        <>
            <TableContainer sx={{display:{lg:'block'}, maxHeight: 300 }} component={Paper}>
                <Table sx={{ overflowY: "scroll" }}>
                    <TableHead>
                        <TableRow>
                            {labelNames && labelNames.map((label, index) => (
                                <TableCell key={index}>{label}</TableCell>
                            ))}
                            <TableCell>ACCIONES</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataRows.length > 0 ? dataRows.map((data, index) => (
                            <TableRow key={index}>
                                <TableCell  sx={tableStyle.bodyCell} align="center">
                                    <Box 
                                        sx={{
                                            display:'flex', 
                                            flexDirection: {xs: 'column', lg: 'row'},
                                            justifyContent: {xs: 'flex-start', lg: 'center'}, 
                                            alignItems: {xs: 'flex-start', lg: 'center'}, 
                                            width:'100%',
                                            height:'100%',
                                            gap: 2
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            inputProps={inputStyle}
                                            name='option' 
                                            value={data.valueName}
                                            error={error}
                                            onChange={(e) => onValueUpdate(e.target.value, index, "valueName")}
                                            disabled={isLoading}
                                        />
                                        <NumberInput
                                            value={data.stock}
                                            unit="Piezas"
                                            onCommit={(e) => {
                                                const newStock = parseInt(e.target.value)
                                                onValueUpdate(newStock, index, "stock")
                                            }}
                                            inputProps={inputStyle}
                                            disabled={isLoading}
                                        />
                                        <NumberInput
                                            value={data.extraDeliveryTime}
                                            unit="Semanas"
                                            onCommit={(e) => {
                                                const newTime = parseInt(e.target.value)
                                                onValueUpdate(newTime, index, "extraDeliveryTime")
                                            }}
                                            inputProps={inputStyle}
                                            disabled={isLoading}
                                        />
                                    </Box>
                                </TableCell>
                                <TableCell  sx={tableStyle.actionCell} align="center">
                                    <Box sx={{display:'flex', gap:'1.5rem', justifyContent:'center', alignItems:'center'}}>
                                        <ActionsButton onDelete={onDeleteModal} rowItem={index}/>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )) :
                            (
                                <TableRow style={{ height: 53 }}>
                                    <TableCell colSpan={6} align='center' >
                                        SIN DATOS
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <DeleteModal title={deleteTitle} confirmButtonText={'Eliminar valor'} onConfirmed={onConfirmDelete} openModal={openModal} onCloseModal={onCloseModal}/>
        </>
    )
}

export default TableCustom